import { terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { JenkinsDeploymentWebhookBodySchema } from '@terra/shared-contracts-git';
import { JENKINS_WEBHOOKS_PATH_NAME } from '../integrations.constants';
export const jenkinsWebhookContract = terraContract.router({
  jenkinsDeploymentWebhook: terraContract
    .meta({ public: true, openApi: true })
    .route({
      method: 'POST',
      path: `/${JENKINS_WEBHOOKS_PATH_NAME}/{tenantId}`,
      summary: 'Jenkins deployment-success webhook',
      description:
        'Call this webhook from your Jenkins pipeline when a production deployment completes successfully. Terra verifies the request signature, then uses the deployment details to re-analyze the affected application(s) so security testing stays aligned with the code now running in production.',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({
          tenantId: z
            .string()
            .describe('Tenant identifier the deployment belongs to.'),
        }),
        body: JenkinsDeploymentWebhookBodySchema,
        headers: z.object({
          'x-terra-signature': z
            .string()
            .describe(
              'HMAC-SHA256 hex digest of the raw request body, keyed with the tenant webhook secret.',
            ),
        }),
      }),
    )
    .output(z.object({ status: z.literal('ok') }))
    .errors({
      BAD_REQUEST: { status: 400, data: z.object({ message: z.string() }) },
      UNAUTHORIZED: { status: 401, data: z.object({ message: z.string() }) },
    }),
});
